export enum carrierConstants {
   vzw = 'VZW',
   'at&t' = 'AT&T',
   msim = 'MSIM' 
}